<div class="scale-wrapper">
  <div class="scale-content" [style.transform]="'scale(' + (scale$ | async) + '%, ' + (scale$ | async) + '%)'">
    <ng-content></ng-content>
  </div>
</div>
